import { getPath } from '@/router/common'
const baseUrl = {
  title: '客户提货',
  path: 'CustomerPickUp'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'CustomerPickUp_index',
    component: () => import(/* webpackChunkName: "CustomerPickUp_index" */ '@/views/customerPickUp/index/index.vue'),
    meta: {
      title: '客户提货'
    }
  },
  {
    path: getPath('PickUpSingle', baseUrl),
    name: 'CustomerPickUp_PickUpSingle',
    component: () => import(/* webpackChunkName: "CustomerPickUp_PickUpSingle" */ '@/views/customerPickUp/pickUpSingle/index.vue'),
    meta: {
      title: '客户提货-提货库存'
    }
  },
  {
    path: getPath('PickUpBatch', baseUrl),
    name: 'CustomerPickUp_PickUpBatch',
    component: () => import(/* webpackChunkName: "CustomerPickUp_PickUpBatch" */ '@/views/customerPickUp/pickUpBatch/index.vue'),
    meta: {
      title: '批量提货'
    }
  },
  {
    path: getPath('PickUpList', baseUrl),
    name: 'CustomerPickUp_PickUpList',
    component: () => import(/* webpackChunkName: "CustomerPickUp_PickUpList" */ '@/views/customerPickUp/pickUpList/index.vue'),
    meta: {
      title: '提货单'
    }
  }
]
